import { render } from "./MedCardView.vue?vue&type=template&id=49b6bf07&scoped=true"
import script from "./MedCardView.vue?vue&type=script&lang=js"
export * from "./MedCardView.vue?vue&type=script&lang=js"

import "./MedCardView.vue?vue&type=style&index=0&id=49b6bf07&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b6bf07"]])

export default __exports__